module.exports = __webpack_public_path__ + "assets/images/pages/stack/stack-header.png?71331777";